<style lang="scss" scoped>
	.mobile {
		height: 100%;
		width: 100%;
		overflow: auto;
	}
	.top {
		position: absolute;
		z-index: 100;
		top: 0;
		width: 100%;
		height: 7vh;
		overflow: hidden;
		.bg {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.top-icon {
			position: absolute;
			left: 0;
			width: auto;
			height: 5.9vh;
			margin-left: 4%;
			margin-top: 4px;
		}
		.right {
			position: absolute;
			right: 0;
			display: flex;
			align-items: center;
			margin-top: 9px;
			.nav-btn {
				width: auto;
				height: 3.7vh;
				margin-right: 20px;
				position: relative;
    			top: 1px;
			}
			.down-btn {
				height: 4.6vh;
				margin-right: 20px;
			}
		}
	}
	.nav-block {
		position: absolute;
		z-index: 100;
		top: 7vh;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(255,233,237,0.73);
		padding-top: 7vh;
		padding-left: 17%;
		padding-right: 17%;
		box-sizing: border-box;
		.nav-item {
			width: 100%;
			height: 12vh;
			line-height: 12vh;
			border-bottom: 2px solid rgba(56,53,48,0.33);
			color: #461e6f;
			font-size: 18px;
			text-align: center;
		}
	}
</style>

<template>
	<div class="mobile">
		<!-- 顶部 -->
		<div class="top">
			<img class="bg" :src="navBackground" alt="">
			<img class="top-icon" :src="navigationIcon" alt="">
			<div class="right">
				<img @click="goDown" class="down-btn" :src="downloadButton" alt="down-btn">
				<img @click="navBlockShow = !navBlockShow" class="nav-btn" src="../assets/mobile/nav-btn.png" alt="nav-btn">
			</div>
		</div>
		<!-- 导航 -->
		<div v-show="navBlockShow" class="nav-block">
			<div v-for="(item, index) in navList" :key="index" @click="goPage(item.path)" class="nav-item">{{item.name}}</div>
		</div>
		<router-view/>
	</div>
</template>

<script>
export default {
	name: 'mobile',
	data() {
		return {
			navBackground: '',
			navigationIcon: null,
			downloadButton: null,
			IOSDown: null,
			AndroidDown: null,
			navBlockShow: false,
			navList: [
				{name: '首页', path: 'm-index'},
				{name: '世界见闻', path: 'm-experience'},
				{name: '羁绊主角', path: 'm-role'},
				{name: '世界特色', path: 'm-characteristic'},
				{name: '声色印象', path: 'm-impression'},
				{name: '世界观', path: 'm-viewpoint'},
			]
		}
	},
	mounted() {
		// const width = document.body.clientWidth;
		// if(width > 850) {
		// 	this.$router.push({name: 'p-index'});
		// } else {
		// 	this.init();
		// }
		this.init();
	},
	methods: {
		init() {
			this.$http.get('/api/website/getGeneralInfo?platform=2').then((rsp) => {
				this.navBackground = rsp.result.navigationFilePath.filePath;
				this.navigationIcon = rsp.result.navigationIcon.filePath;
				this.downloadButton = rsp.result.downloadButton.filePath;
				this.IOSDown = rsp.result.download.appstorePath;
				this.AndroidDown = rsp.result.download.androidPath;
      		});
		},
		goPage(path) {
			this.$router.push({name: path});
			this.navBlockShow = false;
		},
		goDown() {
			var u = navigator.userAgent, app = navigator.appVersion;
			let isAndroid = u.indexOf('Android') > -1; //android终端或者uc浏览器
			let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			if (isAndroid) {
				window.open(this.AndroidDown, '_blank');
			}
			if(isiOS){
				window.open(this.IOSDown, '_blank');
			}
		}
	}
}
</script>